import * as React from 'react';
import { useFormApi } from 'informedv4';
import DatePicker from 'react-datepicker';
import { parse, isValid } from "date-fns";

export const DateTime = ({ name, onChange, ...props }) => {

    const { getFieldState, setValue, setTouched } = useFormApi();
    const MAX_DATE = new Date(9999, 11, 31, 23, 59, 59);

    const dateTime = getFieldState(name).value
        ? new Date(getFieldState(name).value as string)
        : null;

    const handleSelect = (date: Date | null) => {
        if (date) {
            setValue(name, date.toISOString());
            onChange?.();
        }
    }


    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        setTouched(name, true);
        const value = event.target.value;
        const parsedDate = parse(value, props.dateFormat, new Date());

        if (isValid(parsedDate)) {
            setValue(name, parsedDate.toISOString());
        } else {
            setValue(name, null);
        }
        onChange();
    }
    const handleChange = () => { }

    return (
        <>
            <DatePicker onChange={handleChange} className="form-control" maxDate={MAX_DATE} {...props} selected={dateTime} onBlur={handleBlur} onSelect={handleSelect} />

            {getFieldState(name).error ? (
                <span style={{ color: 'red' }}>{getFieldState(name).error as string}</span>
            ) : null}
        </>
    );
};
